module.exports = __webpack_public_path__ + "img/avatar3.2b757062.webp";